import { Injectable } from '@angular/core';

export interface AppPage { key: string; path: string; label: string; icon: string; }

/** หน้าที่กำหนดสิทธิ์รายผู้ใช้ได้ (key ตรงกับ backend: user-pages.ts) */
export const APP_PAGES: AppPage[] = [
  { key: 'main', path: '/main', label: 'หน้าแรก', icon: 'fa-house-chimney' },
  { key: 'car-counting', path: '/car-counting', label: 'นับรถ', icon: 'fa-car-side' },
  { key: 'report', path: '/report', label: 'รายงาน', icon: 'fa-file-excel' },
  { key: 'users', path: '/users', label: 'ผู้ใช้งาน', icon: 'fa-users' },
];

const KEY = 'allowedPages';

/** สิทธิ์เข้าหน้าของผู้ใช้ที่ login อยู่ (เก็บใน localStorage ตอน login; null = ไม่จำกัด) */
@Injectable({ providedIn: 'root' })
export class PageAccessService {
  save(allowed: string[] | null | undefined) {
    if (Array.isArray(allowed)) localStorage.setItem(KEY, JSON.stringify(allowed));
    else localStorage.removeItem(KEY);
  }

  get allowed(): string[] | null {
    try {
      const raw = localStorage.getItem(KEY);
      const v = raw ? JSON.parse(raw) : null;
      return Array.isArray(v) ? v : null;
    } catch { return null; }
  }

  can(page: string): boolean {
    const a = this.allowed;
    return a === null || a.includes(page);
  }

  get visiblePages(): AppPage[] {
    return APP_PAGES.filter(p => this.can(p.key));
  }

  get firstAllowedPath(): string | null {
    return this.visiblePages[0]?.path ?? null;
  }
}
